/*
  DKY | Grid geser - perilaku tombol.

  1) TOMBOL BISA DIKLIK
     Tombol dirender sebagai <span role="link" data-dky-href> (bukan <a>),
     supaya tidak pernah ada <a> di dalam <a class="dky-gg__box">. Tautan
     bersarang membuat browser memotong susunan elemen, dan itulah penyebab
     judul + subjudul jadi berantakan. Skrip ini yang membuat span itu tetap
     bisa diklik (klik, Enter/Spasi, Ctrl/Cmd+klik = tab baru).

  2) TAUTAN TOMBOL DIPISAH DARI TAUTAN KOTAK
     Bila alamat kotak sama persis dengan alamat sebuah tombol di dalamnya,
     alamat kotak dilepas. Jadi alamat yang diisi untuk tombol hanya milik
     tombol itu.

  3) POSISI TOMBOL DIPISAH DARI POSISI TEKS
     Saat posisi tombol dan teks disetel SAMA, section menaruh tombol di
     dalam kotak teks, sehingga tombol ikut bergeser setiap kali jarak teks
     diubah. Skrip ini memindahkan tombol ke lapisannya sendiri, memakai
     angka jarak milik tombol sendiri (dihitung dari tepi kotak, bukan dari
     teks). Hasilnya: mengatur posisi teks tidak lagi menggeser tombol, dan
     sebaliknya. Supaya tetap rapi, teks otomatis diberi ruang sehingga
     tombol SELALU berada DI BAWAH teks ketika posisi keduanya sama.
*/
(function () {
  if (window.__dkyGgBtnReady) return;
  window.__dkyGgBtnReady = true;

  var GAP = 10; // jarak minimal antara teks dan tombol (px)

  /* ---------- 1. Klik tombol ---------- */

  function target(node) {
    if (!node || !node.closest) return null;
    return node.closest('[data-dky-href]');
  }

  function go(el, newTab) {
    var href = el.getAttribute('data-dky-href');
    if (!href) return;
    if (newTab) window.open(href, '_blank', 'noopener');
    else window.location.href = href;
  }

  document.addEventListener('click', function (e) {
    var btn = target(e.target);
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    go(btn, e.metaKey || e.ctrlKey);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var btn = target(e.target);
    if (!btn) return;
    e.preventDefault();
    go(btn, false);
  });

  /* ---------- 2. Lepas tautan kotak bila sama dengan tombol ---------- */

  function unmix(scope) {
    var boxes = scope.querySelectorAll('a.dky-gg__box[href]');
    Array.prototype.forEach.call(boxes, function (box) {
      var boxHref = box.getAttribute('href');
      if (!boxHref) return;
      var btns = box.querySelectorAll('[data-dky-href]');
      var duplicate = Array.prototype.some.call(btns, function (b) {
        return b.getAttribute('data-dky-href') === boxHref;
      });
      if (duplicate) {
        box.removeAttribute('href');
        box.style.cursor = 'default';
      }
    });
  }

  /* ---------- 3. Pisahkan lapisan tombol dari lapisan teks ---------- */

  function childByClass(parent, cls) {
    for (var i = 0; i < parent.children.length; i++) {
      if (parent.children[i].classList.contains(cls)) return parent.children[i];
    }
    return null;
  }

  function px(v) {
    var n = parseFloat(v);
    return isNaN(n) ? 0 : n;
  }

  var watched = [];

  function split(scope) {
    var infos = scope.querySelectorAll('.dky-gg__info:not(.dky-gg__info--btnonly)');
    Array.prototype.forEach.call(infos, function (info) {
      if (info.getAttribute('data-dky-split') === '1') return;
      var btns = childByClass(info, 'dky-gg__btns');
      if (!btns) return;

      var v = function (name) { return info.style.getPropertyValue(name).trim(); };
      var absPx = function (name) { return Math.abs(px(v(name))) + 'px'; };

      var wrap = document.createElement('div');
      wrap.className = 'dky-gg__info dky-gg__info--btnonly dky-gg__info--split';
      if (info.classList.contains('dky-gg__info--hover')) {
        wrap.classList.add('dky-gg__info--hover');
      }

      // Titik labuh sama dengan teks (posisinya memang disetel sama).
      var anchor = {
        '--btnwrap-jc': v('--info-jc') || 'flex-end',
        '--btnwrap-ai': v('--info-ai') || 'flex-start',
        '--btnwrap-ta': v('--info-ta') || 'left',
        '--btnwrap-jc-m': v('--info-jc-m') || 'flex-end',
        '--btnwrap-ai-m': v('--info-ai-m') || 'flex-start',
        '--btnwrap-ta-m': v('--info-ta-m') || 'left'
      };
      Object.keys(anchor).forEach(function (k) { wrap.style.setProperty(k, anchor[k]); });

      // Jarak tombol dihitung dari tepi kotak memakai angka milik tombol.
      wrap.style.setProperty('--btnwrap-pad-x', absPx('--btn-off-x'));
      wrap.style.setProperty('--btnwrap-pad-y', absPx('--btn-off-y'));
      wrap.style.setProperty('--btnwrap-pad-x-m', absPx('--btn-off-x-m'));
      wrap.style.setProperty('--btnwrap-pad-y-m', absPx('--btn-off-y-m'));

      // Perataan baris tombol + geser halus tetap milik tombol.
      ['--btn-justify', '--btn-justify-m', '--btn-nudge-x', '--btn-nudge-y', '--btn-nudge-x-m', '--btn-nudge-y-m'].forEach(function (k) {
        var val = v(k);
        if (val) wrap.style.setProperty(k, val);
      });

      // Jangan pakai geser relatif-terhadap-teks lagi.
      ['--btn-off-x', '--btn-off-y', '--btn-off-x-m', '--btn-off-y-m', '--nudge-x', '--nudge-y', '--nudge-x-m', '--nudge-y-m'].forEach(function (k) {
        wrap.style.setProperty(k, '0px');
      });

      wrap.appendChild(btns);
      info.parentNode.insertBefore(wrap, info.nextSibling);
      info.setAttribute('data-dky-split', '1');
      info._dkyWrap = wrap;

      // Kotak teks yang isinya hanya tombol tidak perlu tampil.
      if (!info.textContent.trim()) info.style.display = 'none';

      watched.push(info);
      observe(info.closest('.dky-gg__tile') || info.parentElement);
    });
  }

  /* Beri ruang supaya tombol selalu di BAWAH teks saat posisinya sama. */
  function stackOne(info) {
    var wrap = info._dkyWrap;
    if (!wrap || info.style.display === 'none') return;

    info.style.paddingBottom = '';
    wrap.style.paddingTop = '';

    // Layout belum siap (gambar/font belum termuat) - jangan hitung dulu.
    if (!info.offsetWidth && !info.offsetHeight) return;

    var btnRow = wrap.firstElementChild;
    var btnH = btnRow ? btnRow.offsetHeight : 0;
    var textH = 0;
    Array.prototype.forEach.call(info.children, function (c) { textH += c.offsetHeight; });
    if (!btnH || !textH) return;

    var jc = getComputedStyle(info).justifyContent;
    if (jc === 'flex-end') {
      // Berlabuh di bawah: angkat teks setinggi tombol.
      info.style.paddingBottom = (px(getComputedStyle(info).paddingBottom) + btnH + GAP) + 'px';
    } else if (jc === 'flex-start') {
      // Berlabuh di atas: turunkan tombol setinggi teks.
      wrap.style.paddingTop = (px(getComputedStyle(wrap).paddingTop) + textH + GAP) + 'px';
    } else {
      // Di tengah: teks naik sedikit, tombol turun sedikit.
      info.style.paddingBottom = (px(getComputedStyle(info).paddingBottom) + btnH + GAP) + 'px';
      wrap.style.paddingTop = (px(getComputedStyle(wrap).paddingTop) + textH + GAP) + 'px';
    }
  }

  function stack() {
    for (var i = 0; i < watched.length; i++) stackOne(watched[i]);
  }

  /* Hitung ulang saat ukuran kartu berubah (gambar selesai dimuat, dll). */
  var ro = null;
  var seen = [];
  if (window.ResizeObserver) {
    var pending;
    ro = new ResizeObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(stack, 60);
    });
  }
  function observe(el) {
    if (!ro || !el || seen.indexOf(el) !== -1) return;
    seen.push(el);
    ro.observe(el);
  }

  /* ---------- Jalankan ---------- */

  function run(root) {
    var scope = root && root.querySelectorAll ? root : document;
    unmix(scope);
    split(scope);
    stack();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(document); });
  } else {
    run(document);
  }

  window.addEventListener('load', stack);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(stack);

  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(stack, 150);
  });

  document.addEventListener('shopify:section:load', function (e) { run(e.target || document); });
})();
